<template lang="pug">
  div(class="billing-autopayment-banner")
    div(class="billing-autopayment-banner__content")
      h3(class="text-16px fw-500 dark mb-1") {{ $t('Automatic withdraw') }}
      p(class="text-12px fw-300 mb-5") {{ subtitle }}
      div(
        v-if="autopaymentCard"
        class="d-flex align-center mb-5"
      )
        div(class="text-14px dark mr-2") {{ autopaymentCard.cardMask }}
        e-chip-label(
          :text="$t('ActiveFeminine')"
          color="#049541"
          background-color="#E1F2E8"
        )
      v-btn(
        outlined
        @click="setupAutopayment"
      ) {{ buttonText }}
    div(class="billing-autopayment-banner__image")
      div(class="billing-autopayment-banner__image-blur")
      v-img(
        :src="require('~/assets/images/debit-card.png')"
        max-width="105"
      )
</template>

<script>
import { mapGetters } from 'vuex'
import EChipLabel from '~/components/elements/chips/e-chip-label'

export default {
  name: 'BillingAutopaymentBanner',
  components: {
    EChipLabel
  },
  computed: {
    ...mapGetters('tranzzo', ['items']),
    autopaymentCard() {
      return this._.get(this.items, '[0]', null)
    },
    buttonText() {
      return this.autopaymentCard ? this.$t('Manage card') : this.$t('Setup autopayment')
    },
    subtitle() {
      return this.autopaymentCard
        ? this.$t('Credit card for automatic payment for Premium plan')
        : this.$t(
            'Autopayment is a feature that allows you to automatically pay for your subscription'
          )
    }
  },
  methods: {
    setupAutopayment() {
      this.$router.push({
        name: 'my-organizations-id-billing',
        params: { id: this.$Organization.id }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.billing-autopayment-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;

  overflow: hidden;

  margin-top: 24px;

  border-radius: 16px;
  border: 1px solid $border-disabled;
  background: $white;

  &__content {
    padding: 16px;
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 16px;

    @media (min-width: map-get($breakpoints, 'lg')) {
      padding-right: 48px;
    }

    flex-basis: 30%;
    position: relative;

    &-blur {
      width: 362px;
      height: 362px;
      border-radius: 362px;
      background: radial-gradient(209.4% 48.46% at 17.83% 57.37%, #fff 0%, #f8e3f4 100%);
      filter: blur(50px);
      position: absolute;
      right: -68px;
      bottom: -135px;
    }
  }
}
</style>
